<script setup lang="ts">
/**
 * The view-owned tools region. Its `#app-chrome-tools` div is a `<Teleport>`
 * target: a view projects its own toolbar/menu subtree here with
 * `<Teleport to="#app-chrome-tools">…</Teleport>`, so those controls stay
 * logically owned by — and reactive within — the view (no state lifting) while
 * rendering in the chrome's DOM region.
 *
 * The target lives in `MainLayout`'s tree (an ancestor of `RouterView`), so it
 * exists before any view mounts and is a stable teleport destination.
 *
 * The default slot is a fallback for shell-level tools (e.g. Home's avatar +
 * settings) on routes that don't teleport their own.
 */
</script>

<template>
  <div class="chrome-tools">
    <div id="app-chrome-tools" class="chrome-tools__teleport" />
    <slot />
  </div>
</template>

<style scoped>
.chrome-tools {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  flex-shrink: 0;
}

.chrome-tools__teleport {
  display: flex;
  align-items: center;
  gap: 4px;
}
</style>
